module.exports = __webpack_public_path__ + "img/Mailbox3.5aeb3d7d.svg";